import React from "react";
import { mediaQueriesNumbers } from "./mediaQueries";

interface StyleSheet {
    [key: string]: React.CSSProperties;
}

const mobile = window.innerWidth <= mediaQueriesNumbers.mobileMax; 

const styles: StyleSheet = {        
    header: {
        fontFamily: "Inter Flex",
        lineHeight: "1", 
        margin: "0px",
        textTransform: "uppercase",
        fontWeight: "500",
        cursor: "default"
    } as React.CSSProperties,

    textShadow:{
        textShadow: "1px 1px 4px #00000060"
    }as React.CSSProperties,
 
    paragraph: {
        fontFamily: "Inter Flex",
        lineHeight: "1.5", 
        margin: "0",
        textTransform: "none",
        fontWeight: "300",
        cursor: "default"
    }  as React.CSSProperties,

    fontWeight0: {
        fontWeight: "100"
    } as React.CSSProperties,
    fontWeight1: {
        fontWeight: "300"
    } as React.CSSProperties,
    fontWeight2: {
        fontWeight: "500"
    } as React.CSSProperties,
    fontWeight3: {
        fontWeight: "700"
    } as React.CSSProperties,

    fontSize0: {
        fontSize: mobile? "30px" : "35px"
    } as React.CSSProperties,
    fontSize1: {
        fontSize: "22px"
    } as React.CSSProperties,
    fontSize2: {
        fontSize: "18px"
    } as React.CSSProperties,
    fontSize3: {
        fontSize: "14px"
    } as React.CSSProperties,
    fontSize4: {
        fontSize: "12px"
    } as React.CSSProperties,
    fontSize5: {
        fontSize: "10px"
    } as React.CSSProperties,
    fontSize6: {
        fontSize: "8px"
    } as React.CSSProperties,
    fontSize7: {
      fontSize: "13px"
  } as React.CSSProperties,
}

export default styles
